import { ApiPropertyOptional } from '@nestjs/swagger'
import { IsOptional, IsUUID, IsEnum } from 'class-validator'
import { OffsetPaginationQueryDto } from '@sphere/shared/domain'
import { Track } from '../../../enums/track.enum'
import { ProgramCategory } from '../../../enums/program-category.enum'

/**
 * DTO for program list filters
 */
/**
 * DTO for program list filters
 */
export class ProgramFilterDto extends OffsetPaginationQueryDto {
  @ApiPropertyOptional({ type: 'string' })
  @IsOptional()
  @IsUUID()
  subjectId?: string

  @ApiPropertyOptional({ type: 'string' })
  @IsOptional()
  @IsUUID()
  levelId?: string

  @ApiPropertyOptional({ enum: Track })
  @IsOptional()
  @IsEnum(Track)
  track?: Track

  @ApiPropertyOptional({ enum: ProgramCategory })
  @IsOptional()
  @IsEnum(ProgramCategory)
  category?: ProgramCategory
}

export class ListProgramsQueryDto
  extends ProgramFilterDto
  implements OffsetPaginationQueryDto {}
